export enum BluetoothStatus {
    unknown = "unknown",
    disconnected = "disconnected",
    connected = "connected",
    connecting = "connecting",
    unavailable = "unavailable"
}
